export function isMobileUA(ua: string): boolean {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    ua,
  )
}

interface NextGenNavigator {
  userAgentData: { mobile: boolean }
}
// User-Agent Client Hints Draft (incoming)
// https://wicg.github.io/ua-client-hints/
function isNextGenNavigator(navigator: unknown): navigator is NextGenNavigator {
  return Boolean((navigator as NextGenNavigator).userAgentData)
}

export function isMobileBrowser(): boolean {
  if (isNextGenNavigator(navigator)) {
    return navigator.userAgentData.mobile
  } else {
    return isMobileUA(navigator.userAgent)
  }
}
